import styled from "styled-components";
import Icon from "../../../../../../base/icons/icon/index.js";
import { FlexMixin, FontMixin } from "../../../../../../../styles/common/mixins/helpers.styled.js";
export const MessageWrapper = styled.div.withConfig({
    displayName: "styled__MessageWrapper",
    componentId: "sc-c3e0cdc4-0"
})`
	padding: 20px;
`;
export const Message = styled.div.withConfig({
    displayName: "styled__Message",
    componentId: "sc-c3e0cdc4-1"
})`
	border: 1px solid ${({ theme  })=>theme.colors.grays.light};
	padding: 16px;
	width: 100%;
	text-align: center;
	${FlexMixin({
    justify: 'center',
    align: 'center',
    direction: 'column'
})}

	& > ${Icon} {
		margin: 12px 0;
		font-size: 30px;
	}

	& p {
		${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})}
		color: ${({ theme  })=>theme.colors.grays.darker}
	}
`;
export const TabProduct = styled.div.withConfig({
    displayName: "styled__TabProduct",
    componentId: "sc-c3e0cdc4-2"
})`
	${($isFlat)=>$isFlat ? 'padding: 0 0 16px;' : 'padding: 0 8px 16px;'}
`;

//# sourceMappingURL=styled.js.map